import { StudentCourseLessonDataT } from "@interfaces/internal-study/students";
import { FC } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";
import course from "@assets/images/course.webp";
import { getCourseThumbnail } from "@utils/getCompanyLogo";
import style from "@scss/pages/study-center.module.scss";

function getUrlThumbnail(thumbnail: string): string {
  if (thumbnail) return getCourseThumbnail(thumbnail);
  return course;
}

export type LessonItemPropsT = {
  lesson: StudentCourseLessonDataT;
  courseId: number;
  finish: boolean;
  last: boolean;
  disabled: boolean;
};

export const LessonItem: FC<LessonItemPropsT> = ({
  lesson,
  courseId,
  finish,
  last,
  disabled,
}) => {
  return (
    <div className={clsx(style.student_courses_item)}>
      <Link
        to={`/course/${courseId}/lesson/${lesson.id}`}
        className={disabled ? style.disable_link : ""}
      >
        <div
          className={clsx(style.student_courses_item_content, {
            [style.finish]: finish,
            [style.disabled]: disabled,
          })}
          style={{
            backgroundImage: `url(${getUrlThumbnail(lesson.thumbnail)})`,
          }}
        >
          {(finish || last) && (
            <div className={clsx(style.student_courses_item_content_counters)}>
              {finish && (
                <p
                  className={clsx(
                    style.student_courses_item_content_counters_text,
                    style.student_courses_item_content_counters_text_all
                  )}
                >
                  Дней до отключения: <span>{lesson.days_disabled}</span>
                </p>
              )}
              {last && (
                <p
                  className={clsx(
                    style.student_courses_item_content_counters_text,
                    style.student_courses_item_content_counters_text_current
                  )}
                >
                  Кол-во попыток в день:{" "}
                  <span>{lesson.max_attempts_per_day}</span>
                </p>
              )}
            </div>
          )}
          <p className={clsx(style.student_courses_item_content_title)}>
            {lesson.title}
          </p>
        </div>
      </Link>
    </div>
  );
};
